/**
 * ColumnStickerRow — `column.sticker` renderer. Paints the parent
 * sticker source's custom cells (and legacy plain-cell sticker arrays)
 * plain cells) as a vertical sticker list in the `column` slot.
 */

import { RendererRow } from "./renderer-row.ts";
import { SourceRow } from "./source-row.ts";

export class ColumnStickerRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `ColumnStickerRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }
}
